'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}let

CompatibilityHelpers=function(){function CompatibilityHelpers(){_classCallCheck(this,CompatibilityHelpers)}CompatibilityHelpers.
getInternetExplorerVersion=function getInternetExplorerVersion(){

var version=-1;

if(navigator.appName=='Microsoft Internet Explorer'){
var ua=navigator.userAgent;
var re=new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
if(re.exec(ua)!=null){
version=parseFloat(RegExp.$1);
}
}

return version;
};CompatibilityHelpers.

isMSIE=function isMSIE(){
return CompatibilityHelpers.getInternetExplorerVersion()!==-1;
};CompatibilityHelpers.

getComponentTypeFromClassName=function getComponentTypeFromClassName(component){
let componentName=component.prototype.constructor.name;

if(componentName.match(/controller$/i)){
return'controller';
}

if(componentName.match(/directive$/i)){
return'directive';
}

if(componentName.match(/commandfactory|errorhandler[s]{0,1}|service$/i)){
return'service';
}

throw new Error(`Unable to determine type of angular component ${component.prototype.constructor.name}, type=${component.type}.`);
};return CompatibilityHelpers}();


module.exports=CompatibilityHelpers;
//# sourceMappingURL=compatibilityHelpers.js.map
